<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / </label>
      <router-link to="/departamento">
        Cadastro/Acesso/Departamentos
      </router-link>
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Ver</label>
    </div>
    <tab-navegacao />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col>
            <v-text-field
              label="Departamento *"
              v-model="descricao"
              :counter="200"
              :rules="[(v) => !!v || 'A Descrição é obrigatória']"
              :readonly="readOnly"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center-left">
          <v-col cols="12" sm="6">
            <v-checkbox
              v-model="departamento.requisicao"
              label="Requisição"
              :readonly="readOnly"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6"> </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="departamento.ativo"
            @click.native.stop.prevent="checkAssociacao()"
            label="Ativo"
            :readonly="readOnly"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" class="text-right">
          <v-btn to="/departamento" color="error" class="mr-4" v-if="!readOnly">
            Voltar
          </v-btn>
          <v-btn to="/departamento" color="success" class="mr-4" v-else>
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly">
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { editarDepartamentoAsync } from "../../../services/departamentoService";
import { mapState, mapActions } from "vuex";
import TabNavegacao from "../../Tabs/TabCadastroUsuario";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "editarDepartamento",
  data: () => ({
    overlay: false,
    valid: true,
    descricao: null,
    readOnly: false,
  }),
  computed: {
    ...mapState("departamento", ["departamento"]),
    ...mapState("usuario", ["usuarios"]),
  },
  methods: {
    ...mapActions("usuario", ["atualizarUsuarios"]),
    ...mapActions("departamento", ["updateDepartamento"]),
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await editarDepartamentoAsync(
          this.departamento.id,
          this.descricao,
          this.departamento.requisicao,
          this.departamento.ativo
        );
        if (
          resposta == null ||
          (resposta.status != null && resposta.status != 200)
        ) {
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          this.updateDepartamento(resposta);
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Atualizado com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/departamento");
        }
      }
    },
    checkAssociacao: async function () {
      if (!this.cargo.ativo) {
        if (!this.usuarios || this.usuarios.length == 0) {
          this.overlay = true;
          await this.atualizarUsuarios();
          this.overlay = false;
        }
        var usuarios = this.findUsuario(this.departamento.id);
        if (usuarios != null && usuarios.length > 0) {
          this.$alert(
            "O(s) usuário(s) '" +
              usuarios.map((e) => e.nome).join("', '") +
              "' estão ativos e associados a esse departamento.",
            "Ação não permitida!",
            "error"
          );
          this.departamento.ativo = !this.departamento.ativo;
        }
      }
    },
  },
  created: function () {
    this.readOnly = !getUserPermission(1);
    this.descricao = this.departamento.descricao;
  },
  components: {
    TabNavegacao,
  },
};
</script>
